@if (!env) {
    <div class="ribbon-banner ribbon-right">BETA Version</div>
}
<div class="layout-topbar">
    <div class="topbar-left">
        <a #menubutton tabindex="0" class="menu-button p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-chevron-left"></i>
        </a>
        <img class="horizontal-logo" [routerLink]="['/']" [src]="'assets/layout/images/logo-'+ logo + '.svg'" alt="diamond-layout"/>
        <span class="topbar-separator"></span>
        <app-breadcrumb></app-breadcrumb>
        <img class="mobile-logo" [src]="'assets/layout/images/logo-'+ logo + '.svg'" alt="diamond-layout"/>
    </div>

    <div class="layout-topbar-menu-section">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-mask modal-in"></div>
    <div class="topbar-right">
        <ul class="topbar-menu">
            <li>{{ todayDate }}</li>
            <li class="static sm:relative">
                <a tabindex="0" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                    <i class="pi pi-bell"></i>
                    <span class="topbar-badge">0</span>
                </a>
                <ul class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-19rem mt-2 right-0 z-5 top-auto">
                    <li>
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <span>Belum ada notifikasi tersedia</span>
                        </a>
                        <!-- <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-shopping-cart mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">New Order</span>
                                <span class="text-color-secondary">You have <strong>3</strong> new orders.</span>
                            </span>
                        </a>
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-check-square mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Withdrawn Completed</span>
                                <span class="text-color-secondary">Funds are on their way.</span>
                            </span>
                        </a>
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-chart-line mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Monthly Reports</span>
                                <span class="text-color-secondary">Monthly Reports are ready.</span>
                            </span>
                        </a>
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-comments mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Comments</span>
                                <span class="text-color-secondary"><strong>2</strong> new comments.</span>
                            </span>
                        </a>
                        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-exclamation-circle mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Chargeback Request</span>
                                <span class="text-color-secondary"><strong>1</strong> to review.</span>
                            </span>
                        </a> -->
                    </li>
                </ul>
            </li>
            <li class="profile-item static sm:relative">
                <a tabindex="0" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                    <img src="assets/statics/mr.png" alt="diamond-layout" class="profile-image"/>
                    <span class="profile-name">{{ userName }}</span>
                </a>
                <ul class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-12rem mt-2 right-0  z-5 top-auto">
                    <li>
                        <a (click)="onProfileClick()" pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-user mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Profil</span>
                            </span>
                        </a>
                        @if (employeeId > 0) {
                            <a href="/private/humans/employee/detail?id={{ employeeId }}" pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                                <i class="pi pi-id-card mr-3"></i>
                                <span class="flex flex-column">
                                    <span class="font-semibold">Kepegawaian</span>
                                </span>
                            </a>
                        }
                        <a (click)="logout()" pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <i class="pi pi-power-off mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">Keluar</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </li>
            <!-- <li class="right-sidebar-item">
                <a tabindex="0" (click)="onRightMenuClick()">
                    <i class="pi pi-align-right"></i>
                </a>
            </li> -->
        </ul>
    </div>
</div>
<p-toast position="bottom-right" />
<p-dialog header="Profil pengguna EMS SSO"
	[(visible)]="isDialogEdit"
	[modal]="true"
	[style]="{width: '30vw'}">
	<ngx-spinner name="spinDialog" bdColor="rgba(0,0,0,0.15)" size="default" color="#333333" type="ball-clip-rotate" [fullScreen]="false">
		<p class="mt-6" style="color: darkslategrey">memproses...</p>
	</ngx-spinner>
	<form [formGroup]="userForm" novalidate>
		<div class="grid">
			<div class="col-12">
				<div class="grid formgrid p-fluid">
					<div class="field col-12 mb-2">
						<label for="user-name" class="req">Nama</label>
						<input pInputText type="text" id="user-name" readonly formControlName="name" class="read-only" />
					</div>
					<div class="field col-12 mb-2">
						<label for="user-email" class="req">Email</label>
						<input pInputText type="email" id="user-email" readonly formControlName="email" class="read-only" />
					</div>
                    <div class="field col-12 mb-5">
						<label for="user-role" class="req">Role</label>
						<input pInputText type="text" id="user-role" readonly formControlName="role" class="read-only" />
					</div>
					<div class="field col-12">
						<p-button label="Ubah kata sandi"  type="button" onclick="window.open('https://sso.emsitpro.com', '_blank')"></p-button>
					</div>
				</div>
			</div>
		</div>
	</form>
</p-dialog>